import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import Helmet from "react-helmet";

import Aqp from "../../libs/mk-react-aqp";

import {fetchStories, resetStories} from "../../creators/stories";
import {fetchTagsProtagonist} from "../../creators/tagsProtagonist";
// import {fetchTagsStories} from "../../creators/stories.tagsStories";

import ArticleGrid from '../components/ArticleGrid';
import Pagination from '../components/Pagination';
import {LoadingBar, PageLoader} from '../components/Loader';
import {Button, ButtonGroup} from "../components/Button";
import Title from "../components/Title";
import Modal from "../components/Modal";
import createLink from "../../libs/createLink";
import AdvancedEditorStory from "../components/advanced-editor/AdvancedEditorStory";
import {Can} from "../../ability-context";
import {canonical} from "../../libs/helper";
import Advertising from "../components/Advertising/Advertising";

let mapping = {
    'tags': 'categories',
    'byUser': 'utilisateur',
};

class Stories extends React.Component {
    constructor(props) {
        super(props);
        // console.log(this.props.location.search);
        this.tagsIsReal = [{_id : 1, title : "Création / fantasme"}, {_id : 2, title : "Histoire réelle"}, {_id : 0, title : "Tous"}];
        this.tagsIsHard = [{_id : 2, title : "Erotique"}, {_id : 1, title : "Hard"}, {_id : 0, title : "Tous"}];
        this.filter = {
            limit: 28,
            sort: "-createdAt",
            page: 1,
            tags: [],
            byUser: "",
            byReal : 0,
            byHard : 0
        };
        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'sort'],
            currentLink: createLink('stories'),
            filterDefault: this.filter
        });
        this.state = {
            filter: {
                ...this.filter, ...this.aqp.query,
                page: this.props.match.params.page || 1,
                // byUser: this.props.match.params.userId || ""
            },
            toggleEditor: false
        };

        if(this.props.match && this.props.match.params.userId){
            this.state.filter.byUser = this.props.match.params.userId;
        }

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleProtagoniste = this.handleProtagoniste.bind(this);
        this.handleUserId = this.handleUserId.bind(this);
        this.handleTags = this.handleTags.bind(this);

        this.getStories(this.state.filter);
        this.props.fetchTagsProtagonist({
            // optionFilter: "protagonist",
            // sort: "option.order"
            isActive : true
        });
        // this.props.fetchTagsStories({
        //     // optionFilter: "story",
        //     // sort: "option.order"
        //     isActive : true
        // });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.location.search !== this.props.location.search && this.props.location.search.length === 0){
            if(prevProps.location.search.replace('?', '').length !== this.props.location.search.replace('?', '').length){
                this.getStories(this.filter);
                this.setState({filter: this.filter});
            }
        }
    }

    componentWillUnmount() {
        this.props.resetStories();
        this.setState({filter: this.filter});
    }

    handleFilter(name, value) {
        let filter = {...this.state.filter, [name]: value, page: 1};
        this.setState({filter});
        this.getStories(filter);
    }

    handleTags(name, value) {
        if(value === this.state.filter[name]){
            value = 0;
        }
        let filter = {...this.state.filter, [name]: value, page: 1};
        this.setState({filter});
        this.getStories(filter);
    }

    getStories(filter) {
        let query = {...filter};
        // if(query.isHard === null){
        //     delete query.isHard;
        // }
        // if(query.isReal === null){
        //     delete query.isReal;
        // }
        // if(query.byUser === ""){
        //     delete query.byUser;
        // }
        this.props.fetchStories(this.aqp.set(query));
    }

    handleUserId(userId) {
        let filter = {...this.state.filter, byUser: userId, page: 1};
        this.setState({filter});
        this.getStories(filter);
        window.scrollTo(0, 0);
    }

    handleProtagoniste(value) {
        let tags = this.state.filter.tags;
        let newTags = [...tags];
        if (Array.isArray(tags)) {
            let protagonistId = this.props.stateTagsProtagonist.map(item => item._id);
            newTags = tags.filter(item => !protagonistId.includes(item));
            if (value !== "") {
                newTags.push(value);
            }
        } else {
            newTags = [value];
        }
        let filter = {...this.state.filter, tags: newTags};
        this.getStories(filter);
        this.setState({filter});

    }

    handleToggle(value) {
        let tags = Array.isArray(this.state.filter.tags) ? this.state.filter.tags : [this.state.filter.tags];
        let newTags = [...tags];
        if (!tags.includes(value)) {
            newTags.push(value);
        } else {
            newTags = tags.filter(item => value.toString() !== item.toString());
        }
        let filter = {...this.state.filter, tags: newTags};
        this.getStories(filter);
        this.setState({filter});
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getStories(filter);
        window.scrollTo(0, 0);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.storiesInitialized !== nextProps.storiesInitialized){
            return true;
        }
        if(this.props.tagsInitialized !== nextProps.tagsInitialized){
            return true;
        }
        if(this.props.storiesLoading !== nextProps.storiesLoading){
            return true;
        }
        if(this.props.storiesTotal !== nextProps.storiesTotal){
            return true;
        }
        if(this.props.match.params !== nextProps.match.params){
            return true;
        }
        if(this.props.stories !== nextProps.stories){
            return true;
        }
        if(this.props.stateTagsProtagonistInitialized !== nextProps.stateTagsProtagonistInitialized){
            return true;
        }

        return this.state !== nextState;
    }

    render() {
        let totalPage = this.props.stories ? Math.ceil(this.props.storiesTotal / this.state.filter.limit) : 0;
        let currentProtagoniste = this.props.stateTagsProtagonist.find(item => this.state.filter.tags.includes(item._id.toString())) || {_id: ""};
        let url = this.aqp.queryUrl(this.state.filter, mapping);
        let currentPage = parseInt(this.state.filter.page);
        return !this.props.storiesInitialized ? (
            <div id="stories">
                <div className="container">
                    <div className="card big">
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="stories">
                <Helmet>
                    <title>Histoire de sexe et histoires érotiques | Voissa {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    <meta name="description" content={"Retrouvez une sélection ✎ d'histoires de sexe ✎, ❤réelles ou fantasmées❤, publiées sur Voissa. Les amateurs de sexe et de récits seront comblés !"} />
                    <meta name="keywords" content={"histoire de sexe, histoire sexe, histoires erotiques, histoire erotique, histoires érotiques, recit erotique, histoires erotisues"} />
                    {currentPage === 2 && (<link rel="prev" href={canonical(url.link, url.search, "stories") }/>)}
                    {currentPage >= 3 && (<link rel="prev" href={canonical(`${url.link}/${(currentPage - 1)}`, url.search, "stories")} />)}
                    <link rel="canonical" href={currentPage >1 ? canonical(`${url.link}/${currentPage}`, url.search, "stories") : canonical(url.link, url.search, "stories")} />
                    {currentPage < totalPage && (<link rel="next" href={canonical(`${url.link}/${(currentPage +1)}`, url.search, "stories")} />)}
                </Helmet>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className="card big">
                        <div className="card-controls">
                            <div className={"main-controls-row"}>
                                <Title heading={"heading-1"} display={"display-2"}>Histoire de sexe</Title>
                                <div className={"filters"}>
                                    {this.state.filter.byUser && (
                                        <Button onClick={() => this.handleUserId("")}
                                                className={"mr-8"}
                                                size={"small"}
                                                btnStyle={"primary-reverse"}
                                                content={"Retour aux histoires"}/>
                                    )}
                                    <Can action="create" subject={"Story"}>
                                        <Button btnStyle={"primary-reverse"}
                                                size={"small"}
                                                onClick={()=>this.setState({toggleEditor: true})}
                                                content={"Ajouter votre histoire érotique"}/>
                                    </Can>
                                    <Modal toggle={this.state.toggleEditor}
                                           handleClose={() => this.setState({toggleEditor: false})}>
                                        <AdvancedEditorStory handleClose={() => this.setState({toggleEditor: false})} />
                                    </Modal>
                                </div>
                            </div>
                            <div className="sub-controls-row">
                                <ButtonGroup>
                                    {this.tagsIsReal.map((item, index) => (
                                        <Button key={`isReal_${index}`}
                                                active={this.state.filter.byReal === item._id ? 'active no-cursor' : ''}
                                                onClick={() => this.state.filter.byReal !== item._id ? this.handleTags("byReal",item._id) : null} content={item.title}/>
                                    ))}
                                </ButtonGroup>
                                <ButtonGroup>
                                    {this.tagsIsHard.map((item, index) => (
                                        <Button key={`isHard_${index}`}
                                                active={this.state.filter.byHard === item._id ? 'active no-cursor' : ''}
                                                onClick={() => this.state.filter.byHard !== item._id ? this.handleTags("byHard",item._id) : null} content={item.title}/>
                                    ))}
                                </ButtonGroup>
                                <select onChange={(event) => this.handleProtagoniste(event.target.value)}
                                        value={currentProtagoniste._id}>
                                    <option value="">Protagonistes ?</option>
                                    {!this.props.stateTagsProtagonistLoading && this.props.stateTagsProtagonist.map(item => (
                                        <option key={item._id} value={item._id}>{item.title}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                            <div className={"column"}>
                                {this.props.storiesLoading && (
                                    <LoadingBar />
                                )}

                                {this.props.storiesTotal > 0 ? (
                                    <ArticleGrid handleUserId={this.handleUserId}
                                                 isStory={true}
                                                 articles={this.props.stories}
                                                 userStories={this.state.filter.byUser.length > 0}
                                                 removeHtml={true}/>
                                ) : (
                                    <div className={"no-content"}>Aucune histoire correspondante à votre recherche</div>
                                )}
                                {totalPage > 1 && (
                                    <Pagination
                                        currentPage={this.state.filter.page}
                                        pagesCount={totalPage}
                                        {...this.aqp.queryUrl(this.state.filter, mapping)}
                                        handleChangePage={this.handleChangePage}
                                    />
                                )}

                                <div className={"footer-stories"}>
                                    <p>Vous trouverez sur cette page toutes les <strong>histoires érotiques</strong> publiées par les membres de Voissa.</p>
                                    <p>Depuis de nombreuses années, notre communauté foisonne de textes, <strong>histoires de sexe</strong>, de récits fantasmés que nous avons souhaité vous lister sur cette page.A l'aide de filtres, cherchez et trouvez les histoires qui vous exciteront : création ou fantasme, histoire réelle, érotique ou hard. Ensuite vous pouvez choisir quels types d'histoire vous aimez, (en fonction de votre sexualité).</p>
                                    <p>Parmi les témoignages vous trouverez les expériences sexuelles, les mésaventures et les rêves érotiques. Dans les créations vous trouverez les fantasmes amoureux et inavoués.</p>
                                    <p><span>Histoire de sexe : les récits des Voissanautes</span></p>
                                    <p>Ce qui est le plus incroyable c'est l'inspiration des Voissanautes sur tous les thèmes que l'on peut imaginer. Indifélité, adultère, gay (et lesbien) masturbation, à plusieurs, dans des endroits insolites ou carrément publics... il n'y a pas de limite. Certaines histoires sont soft, certaines sont hot et enfin d'autres sont carrément hard, le principal étant qu'elles soient bien racontées. Mieux qu'une vidéo ou une photo, le récit sexuel permet de s'imaginer à la place du narrateur, qu'il soit l'inconnu dont une femme fantasme ou l'homme qui fait jouir une femme mariée car l'imagination avec l'écrit n'a pas de limite.</p>
                                    <p>Bien sûr Voissa est ouvert à tous, il n'y a pas de place ici que pour Molière, vous pouvez vous aussi vous lancer et mettre sur papier (façon de parler) <strong>l'histoire de sexe</strong> que vous avez toujours rêvé de raconter sans jamais l'admettre.</p>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        stories: state.stories.data,
        storiesLoading: state.stories.loading,
        storiesInitialized: state.stories.initialized,
        storiesTotal: state.stories.total,

        // tags: state.tagsStories.data,
        // tagsLoading: state.tagsStories.loading,
        // tagsInitialized: state.tagsStories.initialized,
        stateTagsProtagonist: state.tagsProtagonist.data,
        stateTagsProtagonistInitialized: state.tagsProtagonist.initialized,
        stateTagsProtagonistLoading: state.tagsProtagonist.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchStories,
    resetStories,
    fetchTagsProtagonist,
    // fetchTagsStories,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Stories);
